import { api } from "./restUtil";
import { apiQuery } from "utils/queries";

export type Language = {
  code: string;
  english_name: string;
  native_name: string;
};

type AWSConfig = {
  bucket: string;
  cognito: {
    aws_cognito_identity_id: string;
    aws_cognito_token: string;
    aws_cognito_identity_pool_id: string;
  };
  region: string;
};

export function getAWSConfig(): Promise<AWSConfig> {
  return api.get<AWSConfig>("/configuration/aws");
}

// The list changes about never, so it outlives the 20s the query client defaults to.
export const languagesQuery = apiQuery<Language[]>({
  key: "/configuration/languages",
  staleTime: 5 * 60 * 1000,
});
